export const TOGGLE_PASSWORD_TYPE = 'TOGGLE_PASSWORD_TYPE';
